import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'hfs-common-ui';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';
import { useGetCookieConsentEnabled } from '~/config/firebase/remote-config';
import useFleetCookies from '~/domain/legal/hooks/use-fleet-cookies';
import paths from '~/app/paths/paths';
import * as S from './styled';

interface ContentProps {
  acceptAll: () => void;
  rejectNonEssential: () => void;
}

const CookieBannerContent = ({ acceptAll, rejectNonEssential }: ContentProps) => {
  const { t } = useTranslation([InternationalizationNameSpace.CookiePolicy]);

  return (
    <S.CookieBannerDiv data-testid="cookie-banner">
      <S.ContentDiv>
        <S.MessageSpan>{t('banner_message')}</S.MessageSpan>
        <S.PolicyLink href={paths.cookiePolicy.getPath()} target="_blank" rel="noreferrer">
          {t('banner_cookie_policy_link')}
        </S.PolicyLink>
        <S.ButtonsDiv>
          <Button size="medium" onClick={acceptAll}>
            {t('accept_all_button')}
          </Button>
          <Button size="medium" onClick={rejectNonEssential} variant="surface">
            {t('reject_non_essential_button')}
          </Button>
        </S.ButtonsDiv>
      </S.ContentDiv>
    </S.CookieBannerDiv>
  );
};

const CookieBanner = () => {
  const { data: cookieConsentEnabled } = useGetCookieConsentEnabled();
  const { showCookieBanner, acceptAll, rejectNonEssential } = useFleetCookies();

  if (!cookieConsentEnabled || !showCookieBanner) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <CookieBannerContent acceptAll={acceptAll} rejectNonEssential={rejectNonEssential} />
    </Suspense>
  );
};

export default CookieBanner;
